// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();
//     this.cachedMap = new Map();
//     this.focusElement = this.input;
//     this.resetButton.addEventListener('click', this.clear.bind(this));
//     this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
//     this.input.addEventListener('focus', this.onFocus.bind(this));
//     this.searchContent = this.querySelector('.search__content');
//     this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
//     this.header = document.querySelector('header');
//     this.toggleNavigationButton = document.querySelector('.toggle-navigation-button');

//     this.boundHandleClickOutside = this.handleClickOutside.bind(this);
//     document.addEventListener('click', this.boundHandleClickOutside);
//     this.searchProductTypes?.addEventListener('change', this.handleProductTypeChange.bind(this));

//     this.isHeaderSearch = this.closest('header') !== null;
    
//     // Icon-only search mode
//     this.searchContainer = this.closest('.header__search');
//     this.isIconOnlyMode = this.searchContainer?.classList.contains('header__search--icon-only');
//     this.searchIconBtn = this.searchContainer?.querySelector('.header__search-icon-btn');
//     this.searchCloseBtn = this.searchContainer?.querySelector('.header__search-close');
//     this.showSuggestionsOnOpen = this.searchContainer?.dataset.showSuggestions === 'true';
    
//     if (this.isIconOnlyMode && this.searchIconBtn) {
//       this.searchIconBtn.addEventListener('click', this.handleIconClick.bind(this));
//     }
    
//     if (this.isIconOnlyMode && this.searchCloseBtn) {
//       this.searchCloseBtn.addEventListener('click', this.handleCloseClick.bind(this));
//     }

//     document.addEventListener('menu-drawer:open', () => {
//       this.classList.remove('predictive-search-open');
//       document.body.classList.remove('search-open');
//     });

//     this.states = {
//       OPEN: 'predictive-search-open',
//       LOADING: 'btn--loading',
//       SEARCH_OPEN: 'search-open',
//     };
//   }
  
//   handleIconClick(event) {
//     event.preventDefault();
//     event.stopPropagation();
    
//     if (!this.searchContainer.classList.contains('search-expanded')) {
//       this.expandSearch();
//     }
//   }
  
//   handleCloseClick(event) {
//     event.preventDefault();
//     event.stopPropagation();
    
//     if (this.isIconOnlyMode && this.searchContainer?.classList.contains('search-expanded')) {
//       this.collapseSearch();
//     } else {
//       this.toggleSearchState(false);
//     }
//   }
  
//   expandSearch() {
//     this.searchContainer.classList.add('search-expanded');
//     this.searchIconBtn?.setAttribute('aria-expanded', 'true');
    
//     // Show search content if suggestions should be shown
//     if (this.showSuggestionsOnOpen && !this.searchRecommendationEmpty) {
//       this.searchContent?.classList.remove('hidden');
//       document.body.classList.add('search-open');
//     }
    
//     // Focus the input after a short delay for animation
//     setTimeout(() => {
//       this.input?.focus();
//     }, 100);
//   }
  
//   collapseSearch() {
//     this.searchContainer.classList.remove('search-expanded');
//     this.searchIconBtn?.setAttribute('aria-expanded', 'false');
//     this.input.value = '';
//     this.removeAttribute('results');
//     this.toggleSearchState(false);
    
//     // Hide search content
//     if (this.searchRecommendationEmpty) {
//       this.searchContent?.classList.add('hidden');
//     }
//   }

//   get input() {
//     return this.querySelector('input[type="search"]');
//   }
//   get resetButton() {
//     return this.querySelector('button[type="reset"]');
//   }

//   get searchProductTypes() {
//     return this.querySelector('#SearchProductTypes');
//   }

//   onFocus(event) {
//     // If icon-only mode, expand search when input is focused
//     if (this.isIconOnlyMode && !this.searchContainer?.classList.contains('search-expanded')) {
//       this.expandSearch();
//     }
    
//     document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
//     document.documentElement.style.setProperty(
//       '--header-bottom-position',
//       `${parseInt(this.header.getBoundingClientRect().bottom)}px`
//     );
//     if (this.isHeaderSearch && !this.searchRecommendationEmpty) {
//       document.body.classList.add('search-open');
//       this.toggleNavButtonVisibility(false);
//     }

//     if (!this.searchRecommendationEmpty) {
//       this.searchContent.classList.remove('hidden');
//     }
//     this.classList.add('predictive-search-open');
//     if (this.getQuery().length === 0) {
//       if (this.searchRecommendationEmpty) {
//         this.searchContent.classList.add('hidden');
//       }
//       return;
//     }
//     const url = this.setupURL().toString();
//     this.renderSection(url, event);
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   clear(event = null) {
//     event?.preventDefault();
//     this.input.value = '';
//     this.input.focus();
//     this.removeAttribute('results');
    
//     // In icon-only mode, don't collapse on clear, just clear the input
//     if (this.isIconOnlyMode && this.searchContainer?.classList.contains('search-expanded')) {
//       // Keep search expanded, just clear results
//       this.searchContent?.classList.add('hidden');
//       if (this.showSuggestionsOnOpen && !this.searchRecommendationEmpty) {
//         setTimeout(() => {
//           this.searchContent?.classList.remove('hidden');
//         }, 100);
//       }
//     } else {
//       this.toggleSearchState(false);
//     }
//   }

//   handleProductTypeChange(evt) {
//     const query = this.getQuery();
//     if (query.length > 0) {
//       const url = this.setupURL().toString();
//       this.renderSection(url);
//     }
//   }

//   setupURL() {
//     const url = new URL(`${window.shopUrl}${FoxTheme.routes.predictive_search_url}`);
//     let search_term = this.getQuery();
//     if (this.searchProductTypes && this.searchProductTypes.value != '') {
//       search_term = `product_type:${this.searchProductTypes.value} AND ${encodeURIComponent(search_term)}`;
//     }
//     return (
//       url.searchParams.set('q', search_term),
//       url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3),
//       url.searchParams.set('resources[limit_scope]', 'each'),
//       url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this)),
//       url
//     );
//   }

//   onChange() {
//     if (this.getQuery().length === 0) {
//       this.clear();
//       return;
//     }
//     const url = this.setupURL().toString();
//     this.renderSection(url);
//   }

//   renderSection(url) {
//     this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
//   }

//   renderSectionFromCache(url) {
//     const responseText = this.cachedMap.get(url);
//     this.renderSearchResults(responseText), this.setAttribute('results', '');
//   }

//   renderSectionFromFetch(url) {
//     this.setLoadingState(true);

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) throw new Error('Network response was not ok');
//         return response.text();
//       })
//       .then((responseText) => {
//         this.renderSearchResults(responseText);
//         this.cachedMap.set(url, responseText);
//       })
//       .catch((error) => {
//         console.error('Error fetching data: ', error);
//         this.setAttribute('error', 'Failed to load data');
//       })
//       .finally(() => this.setLoadingState(false));
//   }
//   renderSearchResults(responseText) {
//     const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
//     const targetElement = document.getElementById(id);

//     if (targetElement) {
//       const parser = new DOMParser();
//       const parsedDoc = parser.parseFromString(responseText, 'text/html');
//       const contentElement = parsedDoc.getElementById(id);

//       if (contentElement) {
//         this.searchContent?.classList.remove('hidden');
//         targetElement.innerHTML = contentElement.innerHTML;

//         if (this.isHeaderSearch && !document.body.classList.contains('search-open')) {
//           document.body.classList.add('search-open');
//           this.toggleNavButtonVisibility(true);
//           this.classList.add('predictive-search-open');
//         } else {
//           this.classList.add('predictive-search-open');
//         }
//       } else {
//         console.error(`Element with id '${id}' not found in the parsed response.`);
//       }
//     } else {
//       console.error(`Element with id '${id}' not found in the document.`);
//     }
//   }

//   handleClickOutside(event) {
//     const target = event.target;
//     const shouldClose = this.isHeaderSearch
//       ? !this.contains(target) &&
//         !this.searchIconBtn?.contains(target) &&
//         ((target.classList.contains('fixed-overlay') && target.closest('.header-section')) ||
//           target.classList.contains('header__search-close'))
//       : !this.contains(target);

//     if (shouldClose) {
//       if (this.isIconOnlyMode && this.searchContainer?.classList.contains('search-expanded')) {
//         setTimeout(() => this.collapseSearch());
//       } else {
//         setTimeout(() => this.toggleSearchState(false));
//       }
//     }
//   }

//   toggleSearchState(isOpen) {
//     this.classList.toggle(this.states.OPEN, isOpen);
//     if (this.isHeaderSearch) {
//       document.body.classList.toggle(this.states.SEARCH_OPEN, isOpen);
//       this.toggleNavButtonVisibility(!isOpen);
//     }
//     if (!isOpen && this.searchRecommendationEmpty) {
//       this.searchContent?.classList.add('hidden');
//     }
//   }

//   toggleNavButtonVisibility(isOpen) {
//     this.toggleNavigationButton && this.toggleNavigationButton.classList.toggle('is-show', isOpen);
//   }

//   setLoadingState(isLoading) {
//     if (isLoading) {
//       this.setAttribute('loading', 'true');
//       this.resetButton.classList.add(this.states.LOADING);
//     } else {
//       this.removeAttribute('loading');
//       this.resetButton.classList.remove(this.states.LOADING);
//       this.setAttribute('results', 'true');
//     }
//   }
// }
// customElements.define('predictive-search', PredictiveSearch);

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedMap = new Map();
    this.focusElement = this.input;
    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
    this.header = document.querySelector('header');
    this.toggleNavigationButton = document.querySelector('.toggle-navigation-button');

    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.boundHandleClickOutside);

    this.isHeaderSearch = this.closest('header') !== null;
    
    // Icon-only search mode (fully set up in connectedCallback)
    this.searchContainer = null;
    this.isIconOnlyMode = false;
    this.searchIconBtn = null;
    this.searchCloseBtn = null;
    this.showSuggestionsOnOpen = false;

    // Animated placeholder (typewriter) – lines from theme settings
    this.placeholderLines = [];
    if (this.dataset.placeholderLines) {
      this.placeholderLines = this.dataset.placeholderLines.split('|||').map(s => s.trim()).filter(Boolean);
    }
    this.placeholderOverlay = null;
    this.typewriterTimeout = null;
    this.typewriterLineIndex = 0;
    this.typewriterCharIndex = 0;
    this.states = {
      OPEN: 'predictive-search-open',
      LOADING: 'btn--loading',
      SEARCH_OPEN: 'search-open',
    };
  }

  connectedCallback() {
    if (this.input && !this.input.dataset.searchListenersAttached) {
      this.input.dataset.searchListenersAttached = 'true';
      this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
      this.input.addEventListener('focus', this.onFocus.bind(this));
    }
    if (this.resetButton && !this.resetButton.dataset.searchListenersAttached) {
      this.resetButton.dataset.searchListenersAttached = 'true';
      this.resetButton.addEventListener('click', this.clear.bind(this));
    }
    if (this.searchProductTypes && !this.searchProductTypes.dataset.searchListenersAttached) {
      this.searchProductTypes.dataset.searchListenersAttached = 'true';
      this.searchProductTypes.addEventListener('change', this.handleProductTypeChange.bind(this));
    }
    this.searchContainer = this.closest('.header__search');
    if (this.searchContainer) {
      this.isIconOnlyMode = this.searchContainer.classList.contains('header__search--icon-only');
      this.searchIconBtn = this.searchContainer.querySelector('.header__search-icon-btn');
      this.searchCloseBtn = this.searchContainer.querySelector('.header__search-close');
      this.showSuggestionsOnOpen = this.searchContainer.dataset.showSuggestions === 'true';
      if (this.isIconOnlyMode && this.searchIconBtn) {
        this.searchIconBtn.addEventListener('click', this.handleIconClick.bind(this));
      }
      if (this.isIconOnlyMode && this.searchCloseBtn) {
        this.searchCloseBtn.addEventListener('click', this.handleCloseClick.bind(this));
      }
    }
    document.addEventListener('menu-drawer:open', () => {
      this.classList.remove('predictive-search-open');
      document.body.classList.remove('search-open');
    });
    if (this.placeholderLines.length && this.input) {
      this.placeholderOverlay = this.querySelector('.search__placeholder-animated');
      if (!this.placeholderOverlay) {
        this.placeholderOverlay = document.createElement('span');
        this.placeholderOverlay.className = 'search__placeholder-animated';
        this.placeholderOverlay.setAttribute('aria-hidden', 'true');
        this.input.parentNode.insertBefore(this.placeholderOverlay, this.input.nextSibling);
      }
      this.input.placeholder = '';
      if (!this.input.dataset.placeholderListenersAttached) {
        this.input.dataset.placeholderListenersAttached = 'true';
        this.input.addEventListener('focus', () => this.stopPlaceholderTypewriter());
        this.input.addEventListener('blur', () => this.startPlaceholderTypewriter());
        this.input.addEventListener('input', () => {
          if (this.input.value === '' && !this.typewriterTimeout) this.startPlaceholderTypewriter();
        });
        this.startPlaceholderTypewriter();
      }
    }
  }

  startPlaceholderTypewriter() {
    if (!this.placeholderLines.length || !this.input) return;
    this.placeholderOverlay = this.placeholderOverlay || this.querySelector('.search__placeholder-animated');
    if (!this.placeholderOverlay) return;
    this.input.placeholder = '';
    this.placeholderOverlay.style.visibility = '';
    this.tickPlaceholderTypewriter();
  }

  stopPlaceholderTypewriter() {
    if (this.typewriterTimeout) {
      clearTimeout(this.typewriterTimeout);
      this.typewriterTimeout = null;
    }
    if (this.placeholderOverlay) {
      this.placeholderOverlay.style.visibility = 'hidden';
    }
  }

  tickPlaceholderTypewriter() {
    if (!this.placeholderOverlay || !this.placeholderLines.length) return;
    if (this.input.value !== '' || document.activeElement === this.input) {
      this.placeholderOverlay.style.visibility = 'hidden';
      this.typewriterTimeout = setTimeout(() => this.tickPlaceholderTypewriter(), 400);
      return;
    }
    this.placeholderOverlay.style.visibility = '';
    const line = this.placeholderLines[this.typewriterLineIndex];
    if (this.typewriterCharIndex <= line.length) {
      this.placeholderOverlay.textContent = line.slice(0, this.typewriterCharIndex);
      this.typewriterCharIndex++;
      this.typewriterTimeout = setTimeout(() => this.tickPlaceholderTypewriter(), 80);
    } else {
      this.typewriterLineIndex = (this.typewriterLineIndex + 1) % this.placeholderLines.length;
      this.typewriterCharIndex = 0;
      this.typewriterTimeout = setTimeout(() => this.tickPlaceholderTypewriter(), 1200);
    }
  }
  
  handleIconClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.searchContainer && !this.searchContainer.classList.contains('search-expanded')) {
      this.expandSearch();
    }
  }
  
  handleCloseClick(event) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.isIconOnlyMode && this.searchContainer?.classList.contains('search-expanded')) {
      this.collapseSearch();
    } else {
      this.toggleSearchState(false);
    }
  }
  
  expandSearch() {
    if (!this.searchContainer) return;
    this.searchContainer.classList.add('search-expanded');
    this.searchIconBtn?.setAttribute('aria-expanded', 'true');
    
    // Show search content if suggestions should be shown
    if (this.showSuggestionsOnOpen && !this.searchRecommendationEmpty) {
      this.searchContent?.classList.remove('hidden');
      document.body.classList.add('search-open');
    }
    
    // Focus the input after a short delay for animation
    setTimeout(() => {
      this.input?.focus();
    }, 100);
  }
  
  collapseSearch() {
    if (!this.searchContainer) return;
    this.searchContainer.classList.remove('search-expanded');
    this.searchIconBtn?.setAttribute('aria-expanded', 'false');
    this.input.value = '';
    this.removeAttribute('results');
    this.toggleSearchState(false);
    
    // Hide search content
    if (this.searchRecommendationEmpty) {
      this.searchContent?.classList.add('hidden');
    }
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }
  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  get searchProductTypes() {
    return this.querySelector('#SearchProductTypes');
  }

  onFocus(event) {
    // If icon-only mode, expand search when input is focused
    if (this.isIconOnlyMode && !this.searchContainer?.classList.contains('search-expanded')) {
      this.expandSearch();
    }
    
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header?.getBoundingClientRect?.()?.bottom ?? 0)}px`
    );
    if (this.isHeaderSearch && !this.searchRecommendationEmpty) {
      document.body.classList.add('search-open');
      this.toggleNavButtonVisibility(false);
    }

    if (!this.searchRecommendationEmpty) {
      this.searchContent.classList.remove('hidden');
    }
    this.classList.add('predictive-search-open');
    if (this.getQuery().length === 0) {
      if (this.searchRecommendationEmpty) {
        this.searchContent.classList.add('hidden');
      }
      return;
    }
    const url = this.setupURL().toString();
    this.renderSection(url, event);
  }

  getQuery() {
    return this.input.value.trim();
  }

  clear(event = null) {
    event?.preventDefault();
    this.input.value = '';
    this.input.focus();
    this.removeAttribute('results');
    
    // In icon-only mode, don't collapse on clear, just clear the input
    if (this.isIconOnlyMode && this.searchContainer?.classList.contains('search-expanded')) {
      // Keep search expanded, just clear results
      this.searchContent?.classList.add('hidden');
      if (this.showSuggestionsOnOpen && !this.searchRecommendationEmpty) {
        setTimeout(() => {
          this.searchContent?.classList.remove('hidden');
        }, 100);
      }
    } else {
      this.toggleSearchState(false);
    }
  }

  handleProductTypeChange(evt) {
    const query = this.getQuery();
    if (query.length > 0) {
      const url = this.setupURL().toString();
      this.renderSection(url);
    }
  }

  setupURL() {
    const url = new URL(`${window.shopUrl}${FoxTheme.routes.predictive_search_url}`);
    let search_term = this.getQuery();
    if (this.searchProductTypes && this.searchProductTypes.value != '') {
      search_term = `product_type:${this.searchProductTypes.value} AND ${encodeURIComponent(search_term)}`;
    }
    return (
      url.searchParams.set('q', search_term),
      url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3),
      url.searchParams.set('resources[limit_scope]', 'each'),
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this)),
      url
    );
  }

  onChange() {
    if (this.getQuery().length === 0) {
      this.clear();
      return;
    }
    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  renderSection(url) {
    this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
  }

  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.renderSearchResults(responseText), this.setAttribute('results', '');
  }

  renderSectionFromFetch(url) {
    this.setLoadingState(true);

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((responseText) => {
        this.renderSearchResults(responseText);
        this.cachedMap.set(url, responseText);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
        this.setAttribute('error', 'Failed to load data');
      })
      .finally(() => this.setLoadingState(false));
  }
  renderSearchResults(responseText) {
    const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
    const targetElement = document.getElementById(id);

    if (targetElement) {
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(responseText, 'text/html');
      const contentElement = parsedDoc.getElementById(id);

      if (contentElement) {
        this.searchContent?.classList.remove('hidden');
        targetElement.innerHTML = contentElement.innerHTML;

        if (this.isHeaderSearch && !document.body.classList.contains('search-open')) {
          document.body.classList.add('search-open');
          this.toggleNavButtonVisibility(true);
          this.classList.add('predictive-search-open');
        } else {
          this.classList.add('predictive-search-open');
        }
      } else {
        console.error(`Element with id '${id}' not found in the parsed response.`);
      }
    } else {
      console.error(`Element with id '${id}' not found in the document.`);
    }
  }

  handleClickOutside(event) {
    const target = event.target;
    const shouldClose = this.isHeaderSearch
      ? !this.contains(target) &&
        !this.searchIconBtn?.contains(target) &&
        ((target.classList.contains('fixed-overlay') && target.closest('.header-section')) ||
          target.classList.contains('header__search-close'))
      : !this.contains(target);

    if (shouldClose) {
      if (this.isIconOnlyMode && this.searchContainer?.classList.contains('search-expanded')) {
        setTimeout(() => this.collapseSearch());
      } else {
        setTimeout(() => this.toggleSearchState(false));
      }
    }
  }

  toggleSearchState(isOpen) {
    this.classList.toggle(this.states.OPEN, isOpen);
    if (this.isHeaderSearch) {
      document.body.classList.toggle(this.states.SEARCH_OPEN, isOpen);
      this.toggleNavButtonVisibility(!isOpen);
    }
    if (!isOpen && this.searchRecommendationEmpty) {
      this.searchContent?.classList.add('hidden');
    }
  }

  toggleNavButtonVisibility(isOpen) {
    this.toggleNavigationButton && this.toggleNavigationButton.classList.toggle('is-show', isOpen);
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.setAttribute('loading', 'true');
      this.resetButton.classList.add(this.states.LOADING);
    } else {
      this.removeAttribute('loading');
      this.resetButton.classList.remove(this.states.LOADING);
      this.setAttribute('results', 'true');
    }
  }
}
customElements.define('predictive-search', PredictiveSearch);
